import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  icon: {
    padding: theme.spacing[6],
    borderColor: colors.borderSubtle,
    borderRadius: theme.borderRadius.full,
    borderWidth: 1,
    width: 'auto',
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
    color: colors.textPrimary,
    marginBottom: 8,
    textAlign: 'center',
  },
  description: {
    fontSize: 14,
    color: colors.textSecondary,
    textAlign: 'center',
    lineHeight: 20,
  },
}));
